import React, { useState, useEffect, useRef } from "react";
import { fetchData } from "../../../util";
import "./index.css";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import GroupCircle from "./GroupCircle";
import GroupQuarter from "./GroupQuarter";
import GroupCharacter from "./GroupCharacters";
import GroupTables from "./GroupTables";
import Statistic from "./Statistic";
import GroupCovers from "./GroupCovers";

const GroupModal = ({
  groupUsers,
  groupscore,
  input,
  excelDataMain,
  excelDataSub,
}) => {
  const modalRef = useRef(null);
  const [isRendered, setIsRendered] = useState(false);

  const [userdata, setUserdata] = useState([]);
  const [countDataMain, setCountDataMain] = useState([]);
  const [countDataSub, setCountDataSub] = useState([]);
  const [state, setState] = useState([[], [], [], []]);

  const [rUsers, setRUSers] = useState([]);
  const [eUsers, setEUSers] = useState([]);
  const [aUsers, setAUSers] = useState([]);
  const [lUsers, setLUSers] = useState([]);
  const [requirePage, setRequirePage] = useState();

  const [facilitatorUsers, setFacilitatorUsers] = useState([]);
  const [advisorUsers, setAdvisorUsers] = useState([]);
  const [mediatorUsers, setMediatorUsers] = useState([]);
  const [visionaryUsers, setVisionaryUsers] = useState([]);
  const [innovatorUsers, setInnovatorUsers] = useState([]);
  const [adventurerUsers, setAdventurerUsers] = useState([]);
  const [analystUsers, setAnalystUsers] = useState([]);
  const [strategistUsers, setStrategistUsers] = useState([]);
  const [evaluatorUsers, setEvaluatorUsers] = useState([]);
  const [plannerUsers, setPlannerUsers] = useState([]);
  const [scholarUsers, setScholarUsers] = useState([]);
  const [guardianUsers, setGuardianUsers] = useState([]);
  const [requireCharacterPage, setRequireCharacterPage] = useState();

  const setPage = (array, page) => {
    return array.slice(page * 30, (page + 1) * 30);
  };

  const setCharacterPage = (array, page) => {
    return array.slice(page * 10, (page + 1) * 10);
  };

  useEffect(() => {
    if (modalRef.current) {
      setIsRendered(true); // 모달이 렌더링된 후 상태 업데이트
    }
  }, [modalRef]);

  useEffect(() => {
    setUserdata(
      groupUsers.map((user) => {
        return {
          name: user.name,
          mainType: user.mainType,
          subType: user.subType,
        };
      })
    );

    fetchData("newquestion-data.xlsx").then((res) => {
      let count = 0;
      let answers = [];
      let currentKey = null;
      let transformedData = res.map((item) =>
        item.map((i) => {
          if (i.id.startsWith("ABS")) {
            count++;
            return i;
          }
          if (i.id.startsWith("REL")) {
            count++;
            currentKey = i.id;
            answers.push({ [currentKey]: [] });
            return {
              ...i,
              answers: answers[answers.length - 1][currentKey],
            };
          } else {
            answers[answers.length - 1][currentKey].push(i);
          }
        })
      );
      const foramttedData = transformedData.map((item) =>
        item.slice().filter((i) => i !== undefined)
      );
      setState(foramttedData);
    });
  }, []);

  useEffect(() => {
    let countM = { 분석형: 0, 관계형: 0, 도전형: 0, 안정형: 0 };
    let countS = {
      촉진자: 0,
      상담가: 0,
      중재자: 0,
      비전가: 0,
      발명가: 0,
      모험가: 0,
      분석가: 0,
      전략가: 0,
      비평가: 0,
      설계자: 0,
      학자: 0,
      수호자: 0,
    };

    userdata.map((user) => {
      countM = {
        ...countM,
        [user.mainType]: (countM[user.mainType] || 0) + 1,
      };
      countS = {
        ...countS,
        [user.subType]: (countS[user.subType] || 0) + 1,
      };
    });

    let rUsersBefore = [];
    let eUsersBefore = [];
    let aUsersBefore = [];
    let lUsersBefore = [];

    let facilitatorUsersBefore = [];
    let advisorUsersBefore = [];
    let mediatorUsersBefore = [];
    let visionaryUsersBefore = [];
    let innovatorUsersBefore = [];
    let adventurerUsersBefore = [];
    let analystUsersBefore = [];
    let strategistUsersBefore = [];
    let evaluatorUsersBefore = [];
    let plannerUsersBefore = [];
    let scholarUsersBefore = [];
    let guardianUsersBefore = [];

    userdata.map((user) => {
      if (user.mainType == "분석형") rUsersBefore.push(user.name);
      else if (user.mainType == "관계형") eUsersBefore.push(user.name);
      else if (user.mainType == "도전형") aUsersBefore.push(user.name);
      else if (user.mainType == "안정형") lUsersBefore.push(user.name);

      if (user.subType == "모험가") {
        adventurerUsersBefore.push(user.name);
      } else if (user.subType == "상담가") {
        advisorUsersBefore.push(user.name);
      } else if (user.subType == "분석가") {
        analystUsersBefore.push(user.name);
      } else if (user.subType == "비평가") {
        evaluatorUsersBefore.push(user.name);
      } else if (user.subType == "촉진자") {
        facilitatorUsersBefore.push(user.name);
      } else if (user.subType == "수호자") {
        guardianUsersBefore.push(user.name);
      } else if (user.subType == "발명가") {
        innovatorUsersBefore.push(user.name);
      } else if (user.subType == "중재자") {
        mediatorUsersBefore.push(user.name);
      } else if (user.subType == "설계자") {
        plannerUsersBefore.push(user.name);
      } else if (user.subType == "학자") {
        scholarUsersBefore.push(user.name);
      } else if (user.subType == "전략가") {
        strategistUsersBefore.push(user.name);
      } else if (user.subType == "비전가") {
        visionaryUsersBefore.push(user.name);
      }
    });

    const maxLength = Math.max(
      rUsersBefore.length,
      eUsersBefore.length,
      aUsersBefore.length,
      lUsersBefore.length
    );

    const maxLengthCharacter = Math.max(
      facilitatorUsersBefore.length,
      advisorUsersBefore.length,
      mediatorUsersBefore.length,
      visionaryUsersBefore.length,
      innovatorUsersBefore.length,
      adventurerUsersBefore.length,
      analystUsersBefore.length,
      strategistUsersBefore.length,
      evaluatorUsersBefore.length,
      plannerUsersBefore.length,
      scholarUsersBefore.length,
      guardianUsersBefore.length
    );

    let requirePageBefore = maxLength / 30;
    requirePageBefore = Math.ceil(requirePageBefore);

    let requireCharacterPageBefore = maxLengthCharacter / 10;
    requireCharacterPageBefore = Math.ceil(requireCharacterPageBefore);

    setRequirePage(requirePageBefore);
    setRUSers(rUsersBefore);
    setEUSers(eUsersBefore);
    setAUSers(aUsersBefore);
    setLUSers(lUsersBefore);

    setRequireCharacterPage(requireCharacterPageBefore);
    setFacilitatorUsers(facilitatorUsersBefore);
    setAdvisorUsers(advisorUsersBefore);
    setMediatorUsers(mediatorUsersBefore);
    setVisionaryUsers(visionaryUsersBefore);
    setInnovatorUsers(innovatorUsersBefore);
    setAdventurerUsers(adventurerUsersBefore);
    setAnalystUsers(analystUsersBefore);
    setStrategistUsers(strategistUsersBefore);
    setEvaluatorUsers(evaluatorUsersBefore);
    setPlannerUsers(plannerUsersBefore);
    setScholarUsers(scholarUsersBefore);
    setGuardianUsers(guardianUsersBefore);

    setCountDataMain(countM);
    setCountDataSub(countS);
  }, [userdata]);

  if (!groupUsers) return;
  return (
    <div className="GroupModal">
      <GroupCovers groupinfo={input} />

      <GroupTables
        groupinfo={input}
        countDataMain={countDataMain}
        countDataSub={countDataSub}
        total={userdata.length}
        excelDataMain={excelDataMain}
        excelDataSub={excelDataSub}
        userdata={userdata}
      />
      <GroupCircle
        userdata={userdata}
        total={userdata.length}
        groupinfo={input}
        page={0}
      />
      <GroupCircle
        userdata={userdata}
        total={userdata.length}
        groupinfo={input}
        page={1}
      />
      {Array.from({ length: requirePage }).map((_, index) => (
        <GroupQuarter
          key={index}
          total={userdata.length}
          page={index}
          userdata={userdata}
          groupinfo={input}
          rUsers={setPage(rUsers, index)}
          eUsers={setPage(eUsers, index)}
          aUsers={setPage(aUsers, index)}
          lUsers={setPage(lUsers, index)}
        />
      ))}

      {Array.from({ length: requireCharacterPage }).map((_, index) => (
        <GroupCharacter
          key={index}
          total={userdata.length}
          page={index}
          userdata={userdata}
          groupinfo={input}
          facilitatorUsers={setCharacterPage(facilitatorUsers, index)}
          advisorUsers={setCharacterPage(advisorUsers, index)}
          mediatorUsers={setCharacterPage(mediatorUsers, index)}
          visionaryUsers={setCharacterPage(visionaryUsers, index)}
          innovatorUsers={setCharacterPage(innovatorUsers, index)}
          adventurerUsers={setCharacterPage(adventurerUsers, index)}
          analystUsers={setCharacterPage(analystUsers, index)}
          strategistUsers={setCharacterPage(strategistUsers, index)}
          evaluatorUsers={setCharacterPage(evaluatorUsers, index)}
          plannerUsers={setCharacterPage(plannerUsers, index)}
          scholarUsers={setCharacterPage(scholarUsers, index)}
          guardianUsers={setCharacterPage(guardianUsers, index)}
        />
      ))}

      <Statistic
        groupinfo={input}
        groupscore={groupscore}
        state={state[0]}
        total={userdata.length}
      />
      <Statistic
        groupinfo={input}
        groupscore={groupscore}
        state={state[1]}
        total={userdata.length}
      />
      <Statistic
        groupinfo={input}
        groupscore={groupscore}
        state={state[2]}
        total={userdata.length}
      />
      <Statistic
        groupinfo={input}
        groupscore={groupscore}
        state={state[3]}
        total={userdata.length}
      />
    </div>
  );
};

export default GroupModal;
